export type QrCodeHeaderSectionProps = {};

export const FC = (props: QrCodeHeaderSectionProps) => {
  return (
    <div></div>
  );
};
